import React from 'react';
import './TeamItem.css';

import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import { Link } from 'react-router-dom';



const TeamItem = ({ team, type = 'team' }) => { // Default to 'team' if no type is passed

    // Destructuring props
    const { id, image, name, title, accounts } = team;

    // Determine the base path based on the type
    const basePath = type === 'speaker' ? '/Speakers/' : '/Team/';

    return (
        <div className='team-item' key={id}>

            {/* Team member Picture */}
            <img src={image} alt={title} />

            <div className='content'>

                <Link
                    to={{
                        pathname: basePath + name, // Dynamic path based on type
                    }}
                    state={team}>
                    <h3>{name}</h3> {/* Team member name */}
                </Link>
                <p>{title}</p> {/* Team member title */}

                {/* Social media icons */}
                <div className='icon-container'>
                    <a className='icon' href={accounts.facebook}><FaFacebookF /></a>
                    <a className='icon' href={accounts.linkedin}><FaLinkedin /></a>
                    <a className='icon' href={accounts.twitter}><FaXTwitter /></a>
                    <a className='icon' href={accounts.instagram}><FaInstagram /></a>
                </div>

            </div>

        </div>
    );
}

export default TeamItem;